import { Eye } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

// "Seen by X of Y" with the names of who has and hasn't seen an announcement.
export function SeenBy({ msg, members, reads }) {
    const audience = members.filter((m) => m.id !== msg.sender_id);
    const seen = audience.filter((m) => (reads[m.id] || "") >= msg.created_at);
    const unseen = audience.filter((m) => (reads[m.id] || "") < msg.created_at);
    const List = ({ title, rows, tone }) => (
        <div>
            <div className={`overline mb-1.5 ${tone}`}>{title} · {rows.length}</div>
            {rows.length === 0 && <div className="text-xs text-ink/40">Nobody</div>}
            <ul className="space-y-1">{rows.map((m) => <li key={m.id} className="text-sm text-ink/80 truncate">{m.name}<span className="text-ink/40 text-xs">{m.department ? ` · ${m.department}` : ""}</span></li>)}</ul>
        </div>
    );
    return (
        <Popover>
            <PopoverTrigger asChild>
                <button className="mt-1 inline-flex items-center gap-1 text-[11px] font-medium text-klein hover:underline" data-testid={`chat-seen-by-${msg.id}`}>
                    <Eye className="w-3.5 h-3.5" /> Seen by {seen.length} of {audience.length}
                </button>
            </PopoverTrigger>
            <PopoverContent align="end" className="w-72 max-h-80 overflow-y-auto space-y-4" data-testid={`chat-seen-list-${msg.id}`}>
                <List title="Seen" rows={seen} tone="text-emerald-700" />
                <List title="Not yet" rows={unseen} tone="text-amber-700" />
            </PopoverContent>
        </Popover>
    );
}

export default SeenBy;
